// Ozera PDP hero gallery. Swaps the active stage slide when a thumbnail is clicked. No dependency
// on Dawn's media gallery — this hero is a bespoke two-panel layout, not main-product.liquid.
(function () {
  document.querySelectorAll('[data-oz-pdp-media]').forEach(function (media) {
    var thumbs = media.querySelectorAll('[data-oz-thumb]');
    var slides = media.querySelectorAll('[data-oz-slide]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.dataset.ozThumb;

        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', String(t.dataset.ozThumb === index));
        });
        slides.forEach(function (s) {
          s.dataset.active = String(s.dataset.ozSlide === index);
        });
      });
    });
    var stage = media.querySelector('.oz-pdp__stage');
    var startX = 0;
    var startY = 0;
    if (!stage) return;
    stage.addEventListener('touchstart', function (event) {
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (event) {
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
      var index = Array.from(thumbs).findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
      var next = (index + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
      if (thumbs[next]) thumbs[next].click();
    }, { passive: true });
  });
})();
